"use client";

import { ArrowRight } from "lucide-react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { FadeInUp } from "@/components/ui/motion";
import { trackLeadSignup } from "@/lib/analytics";

export function FinalCTA() {
  const navigate = useRouter();

  return (
    <section className="py-20 lg:py-28 section-base relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-primary/10 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <FadeInUp className="relative max-w-3xl mx-auto text-center">
          <div className="relative bg-card rounded-2xl border border-border p-8 sm:p-12 lg:p-16 shadow-xl hover:shadow-2xl transition-shadow duration-500">
            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent rounded-2xl pointer-events-none" />

            <div className="relative">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-4 tracking-tight">
                Ready to automate with clarity?
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground/90 mb-8 sm:mb-10 max-w-xl mx-auto">
                Start free in minutes. Build your first workflow, see it run,
                and understand exactly what happened.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-6">
                <Button
                  // variant="gradient"
                  size="lg"
                  onClick={() => {
                    trackLeadSignup("landing_final_cta");
                    navigate.push("/register");
                  }}
                  className="pulse-cta w-full sm:w-auto"
                >
                  Start free
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  onClick={() => navigate.push("/templates")}
                  className="w-full sm:w-auto"
                >
                  Browse templates
                </Button>
              </div>

              <p className="text-sm text-muted-foreground">
                No credit card required · Free tier available
              </p>
            </div>
          </div>
        </FadeInUp>
      </div>
    </section>
  );
}
